/**
 * The unread/mention badge pair, shared by every surface that signals channel
 * activity — the chat sidebar's guild groups and the guild page's channel rail.
 *
 * Kept in its own module rather than the components barrel: the guilds arche
 * imports this directly by path, and pulling it through `chat/components/index`
 * would drag the barrel (and the TDZ cycle documented there) into the guilds
 * bundle.
 */
export function UnreadBadges({ unread, hasMention }: { unread: number; hasMention: boolean }) {
  return (
    <>
      {hasMention && (
        <span
          aria-label="mentioned"
          className="flex-shrink-0 text-[10px] font-bold rounded-full w-[18px] h-[18px] flex items-center justify-center bg-red-500 text-white"
        >
          @
        </span>
      )}
      {unread > 0 && (
        <span
          aria-label={`${unread} unread`}
          className="flex-shrink-0 text-[10px] font-semibold rounded-full px-1.5 min-w-[18px] h-[18px] flex items-center justify-center bg-red-500 text-white"
        >
          {/* Capped for display; the aria-label keeps the exact count. */}
          {unread > 99 ? '99+' : unread}
        </span>
      )}
    </>
  );
}
